import { ReactElement, useContext, useState } from 'react';

import { FormikHelpers } from 'formik';

import { useStoreData, useStoryblokStrings } from '../../hooks';
import { ApiContext, CoreContext } from '../../providers';
import { StoryblokFormSubmitEvent } from '../../storyblok';

type FormOnSubmit = (args: {
    values: Record<string, unknown>;
    formikHelpers: FormikHelpers<Record<string, unknown>>;
}) => Promise<void>;

export const useFormOnSubmitEvent = (
    formSubmitEvent: StoryblokFormSubmitEvent,
) => {
    const {
        debtCollectionFilesUploaded,
        debtDownloadConfirmText,
        debtDownloadConfirmButton,
    } = useStoryblokStrings('debt-strings');
    const requestKey = useStoreData().user.requestKey;
    const [successScreen, setSuccessScreen] = useState<ReactElement | null>(
        null,
    );
    const [submissionState, setSubmissionState] = useState<
        | { state: 'initial' }
        | { state: 'loading' }
        | {
              state: 'submitted';
              submissionScreen: 'message' | ReactElement;
              renderForm: boolean;
          }
        | { state: 'error' }
    >({ state: 'initial' });

    const { store } = useContext(CoreContext);
    const { Upscore } = useContext(ApiContext);

    const formEvents: {
        [key in StoryblokFormSubmitEvent]: FormOnSubmit;
    } = {
        redirect: async ({ values }) => {
            const redirectPath = values['redirect'];

            window.location.href = `${window.location.origin}/${redirectPath}`;
        },
    };

    return {
        onSubmit: formEvents[formSubmitEvent],
        submissionState,
        setSubmissionState,
    };
};
